import { selectCurrentInstitutionPath } from '../../Institutions/CurrentInstitutionPath/selectors';
import { retrieveInstitutions } from '../../Institutions/dispatchers';

export const getCurrentInstitution = ({ dispatch, getState }) => {
  const currentInstitutionPath = selectCurrentInstitutionPath(getState());
  if (currentInstitutionPath) {
    return dispatch(retrieveInstitutions([currentInstitutionPath]));
  }
  return Promise.resolve();
};
